"use client"

import Link from "next/link"
import { useRouter } from "next/navigation"
import { Header } from "@/components/layout/Header"
import { Footer } from "@/components/layout/Footer"
import { Button } from "@/components/ui/button"
import { ArrowLeft, Home } from "lucide-react"

export default function NotFound() {
  const router = useRouter()

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      
      {/* Main content */}
      <main className="flex flex-1 flex-col items-center justify-center px-4 py-16 md:py-24 text-center">
        {/* Decorative gold line */}
        <div className="mb-8 h-px w-16 bg-accent" />
        
        {/* 404 number with gold accent */}
        <h1 className="mb-4 text-[8rem] font-light leading-none tracking-tighter text-foreground md:text-[12rem]">
          4<span className="text-accent">0</span>4
        </h1>
        
        {/* Tagline */}
        <p className="mb-2 text-xl font-medium tracking-wide text-foreground md:text-2xl">
          Page Not Found
        </p>
        
        <p className="mb-12 max-w-md text-muted-foreground">
          The page you&apos;re looking for doesn&apos;t exist or has been moved. 
          Let&apos;s get you back on track.
        </p>

        {/* Actions */}
        <div className="flex flex-col gap-4 sm:flex-row">
          <Button
            variant="outline"
            size="lg"
            onClick={() => router.back()}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
          
          <Button
            size="lg"
            className="bg-accent text-white hover:bg-accent/90"
            asChild
          >
            <Link href="/">
              <Home className="mr-2 h-4 w-4" />
              Back to Home
            </Link>
          </Button>
        </div>

        {/* Decorative gold line */}
        <div className="mt-16 h-px w-16 bg-accent" />
      </main>

      <Footer />
    </div>
  )
}

